var navigationWeb = {
  index: 0,
  listSummary: [],
  mapSummaryKeyUrl: {},
  mapSummaryUrlKey: {},
  mapSummaryHrefId: {},
  tree: [],
  language: null
}

navigationWeb.nextPage = function () {
  if (navigationWeb.index + 1 <= navigationWeb.listSummary.length - 1) {
    navigationWeb.index = navigationWeb.index + 1;
    navigationWeb.loadPageFromListSummary(navigationWeb.index, "next");
  }
}

navigationWeb.previousPage = function () {
  if (navigationWeb.index - 1 >= 0) {
    navigationWeb.index = navigationWeb.index - 1;
    navigationWeb.loadPageFromListSummary(navigationWeb.index, "previous");
  }
}

navigationWeb.highlightNextPrevious = function () {
  $("[data-button-next='true']").removeAttr("disabled");
  $("[data-button-previous='true']").removeAttr("disabled");

  if (navigationWeb.index >= navigationWeb.listSummary.length - 1) {
    $("[data-button-next='true']").attr("disabled", "true");
  }

  if (navigationWeb.index <= 0) {
    $("[data-button-previous='true']").attr("disabled", "true");
  }
}

navigationWeb.activateKeyboardShortcuts = function () {
  $("body").on("keydown", function (e) {
    if (e.keyCode === 37) {
      if ( rtlDirection.isRtl(navigationWeb.language) === true ) {
        navigationWeb.nextPage();
      }
      else {
        navigationWeb.previousPage();
      }
    } else if (e.keyCode === 39) {
      if ( rtlDirection.isRtl(navigationWeb.language) === true ) {
        navigationWeb.previousPage();
      }
      else {
        navigationWeb.nextPage();
      }
    }
  });
}

navigationWeb.loadPageFromListSummary = function (index, direction) {
  let found = false;
  const id = Object.keys(navigationWeb.mapSummaryKeyUrl)[index];

  const tree = $("#summary-tree-content").fancytree("getTree");
  const listChildren = tree.rootNode.children;

  for (var i = 0; i < listChildren.length; i++) {
    const node = listChildren[i];

    if (id === node.key) {
      if (node.isFolder() === true && node.children !== undefined && node.children != null && direction === "next") {
        const keyChildren = node.children[0].key;

        if (navigationWeb.mapSummaryKeyUrl[keyChildren] !== undefined) {
          const urlChildren = navigationWeb.mapSummaryKeyUrl[keyChildren];
          navigationWeb.activateItemSummaryFromId(keyChildren);

          pap.loadPageChangeHash(urlChildren);
        }

        found = true;
      }
      else if (node.isFolder() === true && node.children !== undefined && node.children != null && direction === "previous") {
        let indexNode = i - 1;

        if (i < 0) {
          indexNode = 0;
        }

        const nodePrevious = listChildren[indexNode];

        if (nodePrevious.isFolder() === true && nodePrevious.children !== undefined && nodePrevious.children != null) {
          const keyChildren = nodePrevious.children[nodePrevious.children.length - 1].key;

          if (navigationWeb.mapSummaryKeyUrl[keyChildren] !== undefined) {
            const urlChildren = navigationWeb.mapSummaryKeyUrl[keyChildren];
            navigationWeb.activateItemSummaryFromId(keyChildren);

            pap.loadPageChangeHash(urlChildren);
          }
        }
        else {
          const keyChildren = nodePrevious.key;

          if (navigationWeb.mapSummaryKeyUrl[keyChildren] !== undefined) {
            const urlChildren = navigationWeb.mapSummaryKeyUrl[keyChildren];
            navigationWeb.activateItemSummaryFromId(keyChildren);

            pap.loadPageChangeHash(urlChildren);
          }
        }

        found = true;
      }

      break;
    }
  }

  if (found === false) {
    if (navigationWeb.mapSummaryKeyUrl[id] !== undefined) {
      const url = navigationWeb.mapSummaryKeyUrl[id];
      navigationWeb.activateItemSummaryFromId(id);

      pap.loadPageChangeHash(url);
    }
  }
}

navigationWeb.initSummary = function (urlToSummary, callback) {
  return $.ajax({
    type: "GET",
    url: urlToSummary,
    dataType: "text",
    async: true,
    error: function (jqXHR, textStatus, errorThrown) {
      console.error("error loading summary: " + textStatus + "=> " + errorThrown);
    }
  }).done(function (data) {

    navigationWeb.createTreeSummaryFromXml(data).then(() => {
      navigationWeb.activateKeyboardShortcuts();

      if (callback !== undefined && callback != null) {
        callback.apply(this, []);
      }

    }).catch((error) => {
      console.error("createTreeSummaryFromXml ERROR: ", error)
    })
  })
}

navigationWeb.clearSummary = function () {
  navigationWeb.listSummary = [];
  navigationWeb.mapSummaryKeyUrl = {};
  navigationWeb.mapSummaryUrlKey = {};
  navigationWeb.mapSummaryHrefId = {}
}

navigationWeb.createTreeSummaryFromXml = async function (dataXml) {
  navigationWeb.clearSummary()

  navigationWeb.createJsonFancyTreeSummary(dataXml).then((source) => {
    source.push(indexAlpha.addMenuItem())

    const $summaryTreeContent = $("#summary-tree-content");

    $($summaryTreeContent).fancytree({
      source: source
    })

    $($summaryTreeContent).fancytree({
      clickFolderMode: 1,
      autoActivate: false,
      activate: function (event, data) {
        const node = data.node
        const key = node.key

        if (navigationWeb.mapSummaryKeyUrl[key] !== undefined && (node.isFolder() === false || node.children === null)) {
          const url = navigationWeb.mapSummaryKeyUrl[key]
          navigationWeb.activateItemSummaryFromId(key)

          pap.loadPageChangeHash(url)

        } else if (node.isFolder() === true) {
          if (node.statusNodeType === "couv") {
            const url = navigationWeb.mapSummaryKeyUrl[key]
            navigationWeb.activateItemSummaryFromId(key)

            pap.loadPageChangeHash(url)

          } else {
            const children = node.children
            const firstNode = children[0]
            const keyChildren = firstNode.key

            if (navigationWeb.mapSummaryKeyUrl[keyChildren] !== undefined) {
              const urlChildren = navigationWeb.mapSummaryKeyUrl[keyChildren]
              navigationWeb.activateItemSummaryFromId(keyChildren)

              pap.loadPageChangeHash(urlChildren)
            }
          }
        }
      },
      enhanceTitle: function (event, data) {
        var node = data.node
        if (node.extraClasses !== undefined && node.extraClasses !== "") {
          var extraClasses = node.extraClasses.trim()
          var extraClassesData = extraClasses.split(" ")

          for (var itemClasses in extraClassesData) {
            if (extraClassesData[itemClasses] !== "show_modification" && extraClassesData[itemClasses] !== "not_show_modification" && extraClassesData[itemClasses] !== "") {
              $(data.$title).append("<span class='addendum " + extraClassesData[itemClasses] + "'/>")
            }
          }
        }
      },
      beforeExpand: function (event, data) {
        if (data.node.isExpanded() === true) {
          if (addendum.showModification === true) {
            navigationWeb.showModificationOnNode(data.node, true)
          }
        } else {
          navigationWeb.showModificationOnNode(data.node, false)
        }
      },
      expand: function (event, data) {
      },
      click: function (event, data) {
        const node = data.node
        const key = node.key

        if (navigationWeb.mapSummaryKeyUrl[key] !== undefined && (node.isFolder() === false || node.children === null)) {
          const url = navigationWeb.mapSummaryKeyUrl[key]
          navigationWeb.activateItemSummaryFromId(key)

          pap.loadPageChangeHash(url)
        }
      }
    })

    return source

  }).catch((error) => {
    console.error("createJsonFancyTreeSummary ERROR: ", error)
  })
}

navigationWeb.createJsonFancyTreeSummary = async function (dataXml) {
  let source = []

  let createSourcePromise = new Promise(function (resolve) {
    const x2js = new X2JS()
    const jsonData = x2js.xml_str2json(dataXml)

    navigationWeb.filterSummary(jsonData["liste"].item)

    resolve(navigationWeb.makeJsonFancyTree(jsonData["liste"], source, 0, false))
  })

  return createSourcePromise.then(() => {
    return source
  })
}

navigationWeb.filterSummary = function (items) {
  for (let item in items) {
    item.isFiltred = false

    let found = true
    if (item.topicref !== undefined && item.topicref._href !== undefined) {
      let searchPromise = loadDDB.searchTopicByHref(item.topicref._href)
      found = searchPromise !== undefined
    }

    if (!found) {
      item.isFiltred = true
    }

    if ( item.item !== undefined && found === true ) {
      navigationWeb.filterSummary(item.item)
    }
  }
}

navigationWeb.makeJsonFancyTree = async function (jsonData, source, nodePosition, isChildren) {

  return new Promise(function (resolve) {
    if (jsonData.item) {
      if (!(jsonData.item instanceof Array)) jsonData.item = [jsonData.item];
      let childrenPosition = 0

      for (let i=0; i < jsonData.item.length; i++) {

        let item = jsonData.item[i]
        const uuid = guid()

        if (item.isFiltred) {
          continue
        }

        const itemSource = {
          "title": item.name,
          "key": uuid,
          "statusNodeType": "",
          "addendum": [],
          "extraClasses": "",
          "px": nodePosition
        }

        const py = childrenPosition
        if (isChildren) {
          itemSource.py = py
        }

        childrenPosition += 1

        if (item.topicref !== undefined) {
          if (item.topicref._href !== undefined) {
            itemSource.href = item.topicref._href

            if (!isChildren) {
              itemSource.id = "recherche-tout." + itemSource.px
            } else {
              itemSource.id = "recherche-tout." + itemSource.px + "." + itemSource.py
            }

            navigationWeb.listSummary.push(itemSource.id)

            navigationWeb.mapSummaryKeyUrl[uuid] = itemSource.id
            navigationWeb.mapSummaryUrlKey[itemSource.id] = uuid
            navigationWeb.mapSummaryHrefId[itemSource.href] = itemSource.id

            navigationWeb.tree.push(itemSource)
          }
          if (item.topicref._navtitle !== undefined) {
            if (item.topicref._navtitle === "rubr-couv") {
              itemSource.statusNodeType = "couv"
            }
          }

          if (item.topicref._status !== undefined) {
            itemSource.addendum.push(item.topicref._status.toLowerCase())
            itemSource.extraClasses = item.topicref._status.toLowerCase()
          }
        }

        if (item.item && item.topicref._navtitle !== "rubr-couv") {
          if (item.item.isFiltred) {
            continue
          }

          if (!(item.item instanceof Array)) { // Un seul item fils
            if (item.item.topicref._href !== undefined) {
              navigationWeb.mapSummaryHrefId[item.item.topicref._href] = itemSource.id
            }
            if (item.item.topicref._status !== undefined) {
              itemSource.addendum.push(item.item.topicref._status.toLowerCase())
              itemSource.extraClasses = item.item.topicref._status.toLowerCase()
            }
          } else {
            itemSource.folder = true
            const children = []

            navigationWeb.makeJsonFancyTree(item, children, nodePosition, true)
            itemSource.children = children

            for (let key in children) {
              const child = children[key]
              for (let keyAddendumChild in child.addendum) {
                const addendumChild = child.addendum[keyAddendumChild]
                itemSource.addendum.push(addendumChild.toLowerCase())
              }

              const listAddendumFiltred = []
              for (let addendum of itemSource.addendum) {
                let found = false

                for (let addendumFiltred of listAddendumFiltred) {

                  if (addendumFiltred === addendum) {
                    found = true
                    break
                  }
                }

                if (!found) {
                  listAddendumFiltred.push(addendum)
                }
              }

              itemSource.addendum = listAddendumFiltred
              itemSource.extraClasses = ""

              for (let keyAddendumFolder in itemSource.addendum) {
                const addendumFolder = itemSource.addendum[keyAddendumFolder]
                if (addendumFolder !== undefined) {
                  itemSource.extraClasses += addendumFolder + " "
                }
              }
            }
          }
        }

        if (!isChildren) {
          nodePosition += 1
        }

        source.push(itemSource);
        if (item === jsonData.item[jsonData.item.length-1]) {
          resolve(source)
        }
      }
    }
  })
}

navigationWeb.updateIndexPage = function (url) {
  for (let i = 0; i < navigationWeb.listSummary.length; i++) {
    if (url === navigationWeb.listSummary[i]) {
      navigationWeb.index = i;
      break;
    }
  }
}

navigationWeb.updateIndexPageById = function (id) {
  let index = 0;
  for (let key in navigationWeb.mapSummaryKeyUrl) {
    if (key === id) {
      navigationWeb.index = index;
      break;
    }

    index += 1;
  }
}

navigationWeb.activateItemSummaryFromUrl = function (url) {
  if (url === "internal/localisation") {
    navigationWeb.index = 0;
    navigationWeb.highlightNextPrevious();
    navigationWeb.activateItemSummaryFromUrl(navigationWeb.listSummary[0]);
  }
  else {
    if (url.indexOf(".dita") < 0) {
      url = url + ".dita";
    }

    if (navigationWeb.mapSummaryUrlKey[url] !== undefined) {
      navigationWeb.updateIndexPage(url);
      navigationWeb.highlightNextPrevious();

      const node = $("#summary-tree-content").fancytree("getTree").getNodeByKey(navigationWeb.mapSummaryUrlKey[url]);
      node.setActive(true, {noEvents: true});
    }
  }
}

navigationWeb.activateItemSummaryFromId = function (id) {
  if (navigationWeb.mapSummaryKeyUrl[id] !== undefined) {
    var url = navigationWeb.mapSummaryKeyUrl[id];
    navigationWeb.updateIndexPageById(id);
    navigationWeb.highlightNextPrevious();

    var node = $("#summary-tree-content").fancytree("getTree").getNodeByKey(id);
    node.setActive(true, {noEvents: true});
  }
}

navigationWeb.updateSummaryFromIndex = function (index) {
  navigationWeb.index = index;
  navigationWeb.highlightNextPrevious();

  const id = Object.keys(navigationWeb.mapSummaryKeyUrl)[index];
  navigationWeb.activateItemSummaryFromId(id);
}

navigationWeb.showModification = function (value, target) {
  var tree = $("#summary-tree-content").fancytree("getTree");
  var listChildren = tree.rootNode.children;

  for (var i = 0; i < listChildren.length; i++) {
    var node = listChildren[i];

    if (node.isFolder() === true) {
      if (node.isExpanded() === false && value === true) {
        navigationWeb.showModificationOnNode(node, true);
      }
      else {
        navigationWeb.showModificationOnNode(node, false);
      }
    } else {
      navigationWeb.showModificationOnNode(node, value);
    }


    if (node.children !== undefined && node.children != null) {
      var children = node.children;

      for (var j = 0; j < children.length; j++) {
        var nodeChild = children[j];

        navigationWeb.showModificationOnNode(nodeChild, value);
      }
    }
  }
}

navigationWeb.showModificationOnNode = function (node, value) {
  if (value === true) {
    $(node.span).find(".addendum").show();
  }
  else {
    $(node.span).find(".addendum").hide();
  }
}

navigationWeb.getTitle = function () {
  var title = ""
  var node = $("#summary-tree-content").fancytree("getTree").getNodeByKey(navigationWeb.mapSummaryUrlKey[navigationWeb.listSummary[navigationWeb.index]]);
  if ( node !== undefined ) {
    title = node.title
  }

  return title
}
